import { all, spawn } from 'redux-saga/effects'

import appSagas from './Ekko/sagas'
import adminSagas from './Admin/sagas'
import usersSagas from './Users/sagas'
import roomsSagas from './Rooms/sagas'
import messagesSagas from './Messages/sagas'
import applicationsSagas from './appList/sagas'
import dashboardSagas from './Dashboard/sagas'
import onboardingSagas from './OnBoardingNow/sagas'
import securityurlSagas from './SecurityUrl/sagas'

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        spawn(appSagas),
        spawn(adminSagas),
        spawn(usersSagas),
        spawn(applicationsSagas),
        spawn(roomsSagas),
        spawn(messagesSagas),
        spawn(dashboardSagas),
        spawn(onboardingSagas),
        spawn(securityurlSagas)
    ])
}
